define('gigaset_csp/components/downloads/list',[
	'jquery',
	'lodash',
	'cartware/components/_base',
	'cartware/jquery/bem',
	'gigaset/spinner',
	'shoptheme/components/ui/tabs',
	'shoptheme/components/tracking'
], function(
	$,
	_,
	Component,
	BEM,
	Spinner,
	Tabs
) {
	return Component.create({

		tabs: null,
		activeTab: null,
		block: null,
		tabsClass: null,
		form: null,
		category: null,
		product: null,
		categorySelect: null,
		productSelect: null,
		tabInput: null,
		productData: null,
		resultListContainer: null,
		resultListTemplate: null,
		xhrCache: null,
		preventReload: false,

		$init: function() {
			this.block = BEM.block('csp-downloads');
			this.tabs = new Tabs();

			this.form = this.block.getElements('form');
			this.tabsClass = '.' + BEM.buildBlockClassname('tabs');

			this.categorySelect = this.block.getElements('category');
			this.productSelect = this.block.getElements('product');
			this.tabInput = this.block.getElements('active-tab');

			var productDataId = 'productData_' + this.block.find('[data-products-id]').data('products-id');
			this.productData = productDataId in window ? window[productDataId] : {};

			this.resultListContainer = BEM.block('csp-downloads-result');

			this.resultListTemplate = _.template(this.block.find('[data-template="resultList"]').html());

			this.xhrCache = {};

			this.bindEvents();
			this.parseUrl();
			$(window).on('hashchange', $.proxy(this.parseUrl, this));
		},

		bindEvents: function() {
			this.categorySelect.on('change', $.proxy(function(e, preventLoop) {
				preventLoop || this.setCategory(this.categorySelect.val());
			}, this));

			this.productSelect.on('change', $.proxy(function(e, preventLoop) {
				preventLoop || this.setProduct(this.productSelect.val());
			}, this));

			this.resultListContainer.on('click', $.proxy(function(e) {
				if ($(e.target).data('tab-id'))
					this.setTab($(e.target).data('tab-id'));
				else if ($(e.target.parentElement).data('tab-id')) {
					this.setTab($(e.target.parentElement).data('tab-id'));
				}
			}, this));
		},

		setCategory: function (value) {
			this.setUrlHash({
				category: value,
				product: null,
				tab: null
			});
		},

		setProduct: function (value) {
			this.setUrlHash({
				product: value
			});
		},

		setTab: function (value) {
			this.preventReload = true;

			this.setUrlHash({
				tab: value
			});
		},

		setCategoryInternal: function(value) {
			this.category = value in this.productData ? this.productData[value] : null;

			if (this.category) {
				this.categorySelect.val(value).trigger('change', true);
				this.fillProductOptions();
			}
		},

		setProductInternal: function (value) {
			if (!value || !this.category) {
				this.productSelect.val('').trigger('change', true);
				this.resultListContainer.html('');
			}

			this.product = _.find(this.category.products, {'uid': value});
			this.productSelect.val(this.product ? value : '').trigger('change', true);
		},

		setTabInternal: function (value) {
			this.activeTab = value;
			this.tabInput.val(value);
		},

		onChange: function() {
			this.resultListContainer.html('');

			if (this.category && this.product) {
				var cacheKey = [this.product.uid, this.category.uid].join("-");

				if (cacheKey in this.xhrCache) {
					this.resultListContainer.html(this.xhrCache[cacheKey]);
				} else {
					this.setLoading(true);

					$.ajax({
						type: this.form.attr('method') || 'POST',
						url: this.form.attr('action'),
						data: this.form.serialize()
					}).then(_.bind(function(results) {
						var html = this.resultListTemplate({
							results: results
						});

						this.setLoading(false);

						this.xhrCache[cacheKey] = html;

						this.resultListContainer.html(html);

						var tabs = this.resultListContainer.find(this.tabsClass);
						this.tabs.initAjax(tabs);
					}, this));
				}
			}

			this.block.trigger('gigaset.content.change');
		},

		fillProductOptions: function() {
			this.productSelect.empty();
			this.productSelect.prop('disabled', false);

			var products = this.category.products;

			_.forEach(products, _.bind(function(product) {
				var option = $('<option value="' + product.uid + '">' + product.name + '</option>');
				option.appendTo(this.productSelect);
			}, this));

			this.productSelect.val('').trigger('change', true);
		},

		parseUrl: function() {
			if (this.preventReload) {
				this.preventReload = false;
				return;
			}

			console.log('PARSE URL');

			var urlMatches = /#(.+)/.exec(document.location);
			var change = false;

			if (urlMatches) {
				this.product = null;
				this.tab = null;

				$.each(urlMatches[1].split('&'), $.proxy(function(i, fragment) {
					var parts = /(.+?)=([^&=]+)/.exec(fragment);

					if (!parts) {
						return;
					}

					if (parts[1] === 'category') {
						change = true;
						this.setCategoryInternal(parts[2]);
					} else if (parts[1] === 'product') {
						change = true;
						this.setProductInternal(parts[2]);
					} else if (parts[1] === 'tab') {
						this.setTabInternal(parts[2]);
					}
				}, this));

				if (change) {
					this.onChange();
				}
			}
		},

		setUrlHash: function(values) {
			var hash = window.location.hash,
				originalHash = hash;

			_.forEach(values, function(value, key) {
				var regex = new RegExp(key + '=[^&=]+');

				if (_.isArray(value)) {
					value = value.join(',');
				}

				if (regex.match(hash)) {
					if (null === value) {
						hash = hash.replace(regex, '');
					} else {
						hash = hash.replace(regex, key + '=' + value);
					}
				} else {
					if (value !== null) {
						hash += hash.substr(0, 1) === '#' ? '&' : '#';
						hash += key + '=' + value;
					}
				}
			});

			hash = hash.replace(/&$/, ''); // strip trailing "&"
			hash = hash.replace(/&&+/, '&');

			if (hash !== originalHash) {
				window.location.hash = hash;
			}
		},

		setLoading: function(status) {
			Spinner[status ? 'add' : 'remove'](this.block);
		}
	});
});
